<div class="w-full h-screen">
  <div class="flex flex-col justify-center items-center h-full">
    <!-- /Logo Box -->
    <div class="flex flex-col h-1/5 w-4/5 place-content-center">
      <a class="h-full w-full flex flex-col justify-center items-center" rel="noopener">
        <img class="w-1/2" [src]="logoUrl" alt="MAKEOS" />
      </a>
    </div>
    <div class="flex flex-col h-4/5 w-4/5 max-w-screen-sm">
      <!-- /Sign in Box -->
      <div *ngIf="signInEmail" class="flex flex-col h-full place-content-center">
        <form class="login-form" [formGroup]="signInGroup" (ngSubmit)="emailSignIn()">
          <div>
            <h2 class="font-bold text-3xl my-8">Log in to {{ env.appTitle || 'Serviceplan MAKEOS' }}</h2>
          </div>
          <!-- Email -->
          <div class="mb-4">
            <div class="w-full">
              <span class="field-label">E-mail address</span>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <input matInput name="email" autocomplete="email" type="text" placeholder="E-mail address" formControlName="email" [attr.data-test-id]="'login-field-email'" />
                <button *ngIf="signInGroup.controls['email'].value" mat-icon-button type="button" (click)="clearInput('email', 'signInGroup')" matSuffix class="cursor-pointer">
                  <mat-icon><span class="material-icons-outlined icon-color-outlined">backspace</span></mat-icon>
                </button>
                <mat-error *ngIf="signInGroup.controls['email'].errors?.['required']"> Email is required </mat-error>
                <mat-error *ngIf="signInGroup.controls['email'].hasError('email') || signInGroup.controls['email'].hasError('invalidEmail')" [attr.data-test-id]="'sign-in-input-email'">
                  Invalid email address
                </mat-error>
              </mat-form-field>
            </div>
          </div>
          <!-- Buttons-->
          <div class="mb-6 w-full">
            <div class="flex flex-col lg:flex-row gap-2 place-content-between">
              <div class="w-full flex flex-col items-center">
                <button mat-flat-button class="w-full button-primary" [disabled]="signInGroup.invalid || disableSignInBtn" type="submit" data-test-id="login-btn-sign-in">Log in</button>
                <!-- Loader -->
                <div class="w-auto h-full pl-2 flex flex-row place-content-between items-center" *ngIf="loading">
                  <mat-spinner [diameter]="30" color="warn"></mat-spinner>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- /Sign in with pwd Box -->
      <div *ngIf="loginWithPwd" class="flex flex-col h-full place-content-center mb-2">
        <form class="login-form" [formGroup]="signInPwdGroup" (ngSubmit)="signInPwd()" *ngIf="loginAvailable">
          <div>
            <h2 class="font-bold text-3xl my-8">Sign in to Serviceplan MAKEOS</h2>
          </div>
          <!-- Email -->
          <div class="mb-4">
            <div class="w-full">
              <span class="field-label">E-mail address</span>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <input matInput readonly type="text" placeholder="E-mail address" formControlName="login_email_username" />
                <button
                  *ngIf="signInPwdGroup.controls['login_email_username'].value"
                  mat-icon-button
                  type="button"
                  (click)="clearInput('login_email_username', 'signInPwdGroup')"
                  matSuffix
                  class="cursor-pointer"
                >
                  <mat-icon><span class="material-icons-outlined icon-color-outlined">backspace</span></mat-icon>
                </button>
                <mat-error *ngIf="signInPwdGroup.controls['login_email_username'].errors?.['required']"> Email is required </mat-error>
                <mat-error *ngIf="signInPwdGroup.controls['login_email_username'].hasError('email')"> Invalid email address </mat-error>
              </mat-form-field>
            </div>
          </div>
          <!-- Password -->
          <div class="mb-4">
            <div class="w-full">
              <div class="flex flex-row place-content-between">
                <span class="field-label">Password</span>
                <span (click)="loginAvailable = !loginAvailable" class="forgot-pwd cursor-pointer text-red"> Forgot password? </span>
              </div>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <input autofocus matInput type="password" placeholder="Password" formControlName="login_password" data-test-id="login-field-password" />
                <button *ngIf="signInPwdGroup.controls['login_password'].value" mat-icon-button (click)="clearInput('login_password', 'signInPwdGroup')" type="button" matSuffix class="cursor-pointer">
                  <mat-icon><span class="material-icons-outlined icon-color-outlined">backspace</span></mat-icon>
                </button>
                <mat-error *ngIf="signInPwdGroup.controls['login_password'].errors?.['required']"> Password is required </mat-error>
                <mat-error *ngIf="signInPwdGroup.controls['login_password'].hasError('minlength')"> Password isn't long enough, minimum of 8 characters </mat-error>
              </mat-form-field>
            </div>
          </div>
          <!-- Buttons-->
          <div class="mb-6 w-full">
            <div class="w-full flex flex-col place-content-between items-center">
              <button [disabled]="loading" mat-flat-button class="flex-auto w-full button-primary" type="submit" data-test-id="login-btn-sign-in">Log in</button>
            </div>
          </div>
          <!--Error Message-->
          <div class="text-center font-bold mt-2 w-full text-red" *ngIf="message">
            <h4>{{ message }}</h4>
          </div>
          <!-- Loader -->
          <div class="w-full flex justify-center items-center" *ngIf="loading">
            <mat-spinner [diameter]="30" color="warn"></mat-spinner>
          </div>
        </form>

        <!-- Forgot password email group -->
        <form class="login-form" [formGroup]="forgotPasswordGroup" (ngSubmit)="forgotPassword()" *ngIf="!loginAvailable">
          <div>
            @if (maxFailedLoginAttempts) {
              <h2 class="font-bold text-xl text-center mb-6" i18n>Account locked</h2>
              <p class="text-center" i18n>Account locked after 5 failed login attempts.</p>
              <p class="text-center mb-8" i18n>Please reset your password or notify your support.</p>
            } @else {
              <h2 class="font-bold text-3xl my-8">Forgot Password</h2>
            }
          </div>
          <!-- Email -->
          <div class="mb-4">
            <div class="w-full">
              <span class="field-label">E-mail address</span>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <input matInput type="text" placeholder="E-mail address" formControlName="email" />
                <button *ngIf="forgotPasswordGroup.controls['email'].value" type="button" mat-icon-button (click)="clearInput('email', 'forgotPasswordGroup')" matSuffix class="cursor-pointer">
                  <mat-icon><span class="material-icons-outlined icon-color-outlined">backspace</span></mat-icon>
                </button>
                <mat-error *ngIf="forgotPasswordGroup.controls['email'].errors?.['required']"> Email is required </mat-error>
                <mat-error *ngIf="forgotPasswordGroup.controls['email'].hasError('email')"> Invalid email address </mat-error>
              </mat-form-field>
            </div>
          </div>
          <!-- Buttons-->
          <div class="mb-6 w-full">
            <div class="flex flex-col lg:flex-row gap-2 place-content-between">
              <div *ngIf="!maxFailedLoginAttempts" class="flex flex-row items-center">
                <button class="flex w-48 lg:w-auto" type="button" (click)="loginAvailable = !loginAvailable">
                  <mat-icon class="material-icons-outlined">chevron_left</mat-icon>
                  <span>Back to login</span>
                </button>
              </div>

              <div class="flex flex-row items-center">
                <button class="w-48 lg:w-auto button-primary" mat-raised-button [disabled]="forgotPasswordGroup.invalid || disableResetPwdBtn" type="submit">Reset Password</button>

                <!-- Loader -->
                <div class="w-auto h-full pl-2 flex flex-row items-center" *ngIf="loading">
                  <mat-spinner [diameter]="30" color="warn"></mat-spinner>
                </div>
              </div>
            </div>
          </div>
          <!--Error Message-->
          <div class="text-center font-bold mt-2 w-full text-red" *ngIf="message && loginAvailable">
            <h4>{{ message }}</h4>
          </div>
        </form>
      </div>

      <!-- /Sign in with sso Box -->
      <div *ngIf="loginWithSSO" class="flex flex-col h-full place-content-center mb-2">
        <form class="login-form" [formGroup]="signInSSOGroup" (ngSubmit)="loginAzure()">
          <div>
            <h2 class="font-bold text-3xl my-8">Sign in to Serviceplan MAKEOS</h2>
          </div>
          <!-- Email -->
          <div class="mb-4">
            <div class="w-full">
              <span class="field-label">E-mail address</span>
              <mat-form-field appearance="outline" floatLabel="auto" class="w-full">
                <input autofocus matInput readonly type="text" placeholder="E-mail address" formControlName="email" />
                <button *ngIf="signInSSOGroup.controls['email'].value" mat-icon-button type="button" (click)="clearInput('email', 'loginWithSSO')" matSuffix class="cursor-pointer">
                  <mat-icon><span class="material-icons-outlined icon-color-outlined">backspace</span></mat-icon>
                </button>
                <mat-error *ngIf="signInSSOGroup.controls['email'].errors?.['required']"> Email is required </mat-error>
                <mat-error *ngIf="signInSSOGroup.controls['email'].hasError('email')"> Invalid email address </mat-error>
              </mat-form-field>
            </div>
          </div>
          <!-- Buttons-->
          <div class="mb-6 w-full">
            <div class="flex flex-col lg:flex-row gap-2 place-content-between">
              <div class="w-full flex flex-col items-center">
                <button id="somebutton" [disabled]="loading" [disabled]="signInSSOGroup.invalid || loading" class="flex-auto w-full button-primary" fxFlex="45" mat-flat-button type="submit">
                  <mat-icon class="mr-2" svgIcon="sp-brand" alt="Serviceplan"></mat-icon>
                  Serviceplan Log in
                </button>
                <!-- Loader -->
                <div class="w-auto h-full pl-2 flex flex-row place-content-between items-center mt-2" *ngIf="loading">
                  <mat-spinner [diameter]="30" color="warn"></mat-spinner>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      <!-- Sign up link -->
      <div *ngIf="env.environment !== 'LIVE'" class="sign-up-link flex flex-col h-full justify-start items-center">
        <p>
          <span class="sign-up-message text-gray-600">Don't have an account? </span>
          <a href="./sign-up" class="sign-up-link">Sign up here</a>
        </p>
      </div>

      <!-- /Footer -->
      <sp-footer></sp-footer>
    </div>
  </div>
</div>
